import React, { useState } from 'react';
import { Box, Button, Typography, LinearProgress, Chip, IconButton } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../services/api';

export default function FileUpload({ onFilesChange, existingFiles = [] }) {
  const [uploading, setUploading] = useState(false);
  const [files, setFiles] = useState(existingFiles);
  const [error, setError] = useState('');

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setError('');

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      const newFiles = [...files, { url: res.data.url, name: res.data.filename, size: res.data.size }];
      setFiles(newFiles);
      onFilesChange(newFiles);
    } catch (err) {
      setError('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (index) => {
    const newFiles = files.filter((_, i) => i !== index);
    setFiles(newFiles);
    onFilesChange(newFiles);
  };

  const formatSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 600, color: '#1a237e', mb: 1 }}>
        Attachments
      </Typography>

      <Box sx={{ border: '2px dashed #e8eaf6', borderRadius: 2, p: 3, textAlign: 'center', bgcolor: '#f5f6fa', mb: 2 }}>
        <CloudUploadIcon sx={{ fontSize: 40, color: '#9fa8da', mb: 1 }} />
        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
          Upload PDF, Word, or image files (max 10MB)
        </Typography>
        <Button variant="outlined" component="label" size="small"
          sx={{ borderColor: '#1a237e', color: '#1a237e', borderRadius: 2 }}
          disabled={uploading}>
          {uploading ? 'Uploading...' : 'Choose File'}
          <input type="file" hidden accept=".pdf,.doc,.docx,.jpg,.jpeg,.png" onChange={handleUpload} />
        </Button>
        {uploading && <LinearProgress sx={{ mt: 2, borderRadius: 1 }} />}
        {error && <Typography variant="caption" sx={{ color: 'red', display: 'block', mt: 1 }}>{error}</Typography>}
      </Box>

      {files.map((file, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, p: 1.5, bgcolor: '#e8eaf6', borderRadius: 2 }}>
          <AttachFileIcon sx={{ fontSize: 18, color: '#1a237e' }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, fontSize: 13 }}>
              <a href={file.url} target="_blank" rel="noreferrer" style={{ color: '#1a237e', textDecoration: 'none' }}>
                {file.name}
              </a>
            </Typography>
            {file.size && <Typography variant="caption" sx={{ color: '#999' }}>{formatSize(file.size)}</Typography>}
          </Box>
          <IconButton size="small" onClick={() => handleRemove(index)} sx={{ color: '#c62828' }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
}
